module.exports = __webpack_public_path__ + "static/DY2-c91e90b9e5e8a01e5136820fc187261c.jpg";